import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const autoManagedStaticData = {
  menuTitle: MenuTitle.AutoManaged
};
export const Route = createFileRoute('/_private-routes/auto-managed')({
  staticData: autoManagedStaticData
});
